import React from 'react';
import { FileCheck2 } from 'lucide-react';
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '../ui/alert-dialog.js';
import { resolveVisitDisplay } from '../../utils/displayLabels.js';

const VehicleInvoiceIssueConfirmDialog = ({ open, onOpenChange, visit, isLoading = false, onConfirm }) => {
    const visitLabel = resolveVisitDisplay(visit, 'المحددة');

    return (
        <AlertDialog open={open} onOpenChange={(nextOpen) => !isLoading && onOpenChange?.(nextOpen)}>
            <AlertDialogContent dir="rtl" className="border-0 p-0 bg-transparent" data-testid="vehicle-invoice-issue-confirm-dialog">
                <div
                    className="rounded-[28px] overflow-hidden"
                    style={{
                        background: 'radial-gradient(circle at 12% 18%, rgba(16,185,129,0.24), transparent 52%), radial-gradient(circle at 88% 78%, rgba(59,130,246,0.14), transparent 55%), rgba(15,23,42,0.98)',
                        border: '1px solid rgba(52,211,153,0.34)',
                        boxShadow: '0 40px 140px rgba(2,6,23,0.9)',
                    }}
                >
                    <AlertDialogHeader className="px-6 pt-6 text-right">
                        <div className="flex items-start gap-3">
                            <div className="w-12 h-12 rounded-2xl bg-emerald-400/15 border border-emerald-300/25 flex items-center justify-center shrink-0">
                                <FileCheck2 className="text-emerald-100" size={22} />
                            </div>
                            <div>
                                <AlertDialogTitle className="text-slate-50 text-lg font-bold">إصدار فاتورة مبيعات</AlertDialogTitle>
                                <AlertDialogDescription className="text-slate-200/80 text-sm mt-2 leading-6">
                                    ستُصدر فاتورة للزيارة {visitLabel}. هذا إجراء حفظ مستقل عن الطباعة، ولا يمكن إصداره إلا للزيارة المعتمدة ماليًا.
                                </AlertDialogDescription>
                            </div>
                        </div>
                    </AlertDialogHeader>
                    <AlertDialogFooter className="px-6 pb-6 pt-5 gap-2 sm:gap-3 sm:justify-end">
                        <AlertDialogCancel className="apple-button-secondary" disabled={isLoading} data-testid="vehicle-invoice-issue-cancel">
                            إلغاء
                        </AlertDialogCancel>
                        <AlertDialogAction
                            className="h-11 px-4 rounded-xl bg-emerald-600 hover:bg-emerald-500 text-white text-sm font-bold disabled:opacity-50"
                            data-testid="vehicle-invoice-issue-submit"
                            disabled={isLoading}
                            onClick={(event) => {
                                event.preventDefault();
                                onConfirm?.();
                            }}
                        >
                            {isLoading ? 'جارٍ إصدار الفاتورة...' : 'إصدار الفاتورة ثم فتحها'}
                        </AlertDialogAction>
                    </AlertDialogFooter>
                </div>
            </AlertDialogContent>
        </AlertDialog>
    );
};

export default VehicleInvoiceIssueConfirmDialog;
